import { useMutation } from "@tanstack/react-query";

import { orpc } from "@/client";
import { useConversationSession } from "@/hooks/use-conversation-session";

export function useCopilotDraft({
	personId,
	windowClosed,
}: {
	personId: number;
	windowClosed: boolean;
}) {
	const { session, draft } = useConversationSession(personId);
	const { mutate } = useMutation(
		orpc.draft.draft.mutationOptions({
			onSuccess: (result, variables, revision: number) => {
				if (session.state.revision !== revision) {
					return;
				}

				session.patch({
					text: result.draft,
					suggestion: result,
					directed: !!variables.human_direction,
					revision: revision + 1,
				});
			},
			onMutate: () => {
				session.patch({ suggesting: true, suggestionError: false });

				return session.state.revision;
			},
			onError: () => session.patch({ suggestionError: true }),
			onSettled: () => session.patch({ suggesting: false }),
		}),
	);

	const generate = () => {
		if (session.state.suggesting || session.state.sending || session.state.audio) {
			return;
		}

		mutate({
			person_id: personId,
			mode: windowClosed ? "reactivation" : "response",
			force: !!draft.suggestion,
			human_direction: draft.direction.trim() || undefined,
		});
	};

	return { generate };
}
